module.exports = __webpack_public_path__ + "static/media/boomer.6fd53fcd.svg";